export default "__VITE_ASSET__DiM95f5F__"